// extracted by mini-css-extract-plugin
export var copyableField = "_nw-4";
export var customerBadge = "_nw-0";
export var customerInfoTitle = "_nw-2";
export var details = "_nw-1";
export var dropdownContainer = "_nw-5";
export var dropdownImage = "_nw-6";
export var editAssigneeForm = "_nw-a";
export var editButton = "_nw-3";
export var email = "_nw-7";
export var hidden = "_nw-d";
export var input = "_nw-8";
export var saveButton = "_nw-b";
export var shopifyIcon = "_nw-c";
export var suggestionBadge = "_nw-e";
export var suggestionText = "_nw-f";
export var username = "_nw-9";